var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.adList),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('a',{attrs:{"target":"_blank","href":item.url}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":item.face_file}})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }